<template>
	<div>
		<form @keyup.enter="filter()" @submit.prevent>
			<div class="row pt-3">
				<div class="col-md-4">
					<text-input v-model="form.text" placeholder="Pesquisar" />
				</div>
				<div class="col-md-4">
					<button
						type="button"
						class="btn btn-sm btn-primary  mr-3"
						@click="showFilters = !showFilters"
					>
						<i class="fas fa-filter" /> Mais Filtros
					</button>
					<button
						type="button"
						class="btn btn-sm btn-primary"
						@click="filter()"
					>
						<i class="fas fa-search" /> Pesquisar
					</button>
				</div>
			</div>
			<b-collapse v-model="showFilters">
				<b-row align-v="center">
					<b-col>
						<category-search
							ref="CategorySearch"
							@categorySelected="setCategory($event)"
						/>
					</b-col>
					<b-col>
						<text-input v-model="form.brand" alias="Marca" />
					</b-col>
					<b-col>
						<number-input v-model="form.max_value" alias="Estoque Maior que" />
					</b-col>
					<b-col>
						<number-input v-model="form.min_value" alias="Estoque Menor que:" />
					</b-col>
          <b-col>
            	<b-form-checkbox
							switch
							@change="filter()"
							:value="1"
							:unchecked-value="0"
							v-model="form.min_stock"
						>
							<small>Selecionar estoque minimo</small>
						</b-form-checkbox>
          </b-col>
				</b-row>
				<b-row>
					<b-col>
						<!-- <date-input v-model="form.saved_at_start" alias="Data Inicial" /> -->
					</b-col>
					<b-col>
						<!-- <date-input v-model="form.saved_at_end" alias="Data Final" /> -->
					</b-col>
				</b-row>
				<b-row>
					<b-col md="2">
						<b-button @click="clear()" class="x-small" size="sm">
							<i class="fas fa-times" /> Limpar Filtro
						</b-button>
					</b-col>
					<b-col>
						<b-form-checkbox
							switch
							inline
							@change="filter()"
							:value="1"
							:unchecked-value="0"
							v-model="form.status"
						>
							<small>Listar Somente Ativos</small>
						</b-form-checkbox>
					</b-col>
				</b-row>
			</b-collapse>
		</form>
	</div>
</template>

<script>
	import Form from "../../../mixins/Form";
	import CategorySearch from "../../CategorySearch";

	export default {
		components: {
			CategorySearch
		},

		data: function () {
			return {
				showFilters: false,

				form: {
					status: 1,
					text: null,
					brand: null,
					max_value: null,
					min_value: null,
          min_stock: 0,
					category_id: null,
					category_description: null,
				}
			};
		},

		watch: {
			form: {
				// This will let Vue know to look inside the array
				deep: true,

				// We have to move our method to a handler field
				handler() {
					this.$emit("input", this.form);
				}
			}
		},

		methods: {
			setCategory(category) {
				this.form.category_id = category.id
				this.form.category_description = category.description
			},

			clear() {
				this.$refs.CategorySearch.clear();
				(this.form.text = null),
					(this.form.max_value = 0),
					(this.form.min_value = 0),
					(this.form.brand = null),
					(this.form.status = 0),
					(this.form.category_id = null),
					this.$emit("filter");
			},

			filter() {
				this.$emit("filter");
			}
		}
	};
</script>

<style>
</style>
